type Config = {
  version: string;
  isLocalhost: boolean;
  byPassSingpassToken: string
  byPassPayment: boolean;
  allowMultipleApplicationDebug: boolean;
  allowPredefinedApplicationCreation: boolean;
  singpassLoginUrl: string;
  myHdbLoginURL: string;
  singpassLogoutUrl: string;
  devAndStgPaymentURL: string;
  prodPaymentURL: string;
  showEstimateFees: boolean;
  singpassRedirectUrl: string;
  corppassRedirectUrl: string;
  byPassBB13: boolean;
  bypassEstateActionCode: boolean;
  skipOutstandingFeesCheck: boolean;
};

let config: Config = {
  version: `${process.env.REACT_APP_RELEASE_VERSION} - 250527.1517`,
  isLocalhost: process.env.REACT_APP_IS_LOCALHOST === "true",
  byPassSingpassToken : `U1BDUFNraXBBdXRoZW50aWNhdGlvbg==`,
  byPassPayment : process.env.REACT_APP_BYPASS_PAYMENT === "true",
  allowMultipleApplicationDebug : process.env.REACT_APP_ALLOW_APPLICATION_DEBUG === "true",
  allowPredefinedApplicationCreation: process.env.REACT_APP_ALLOW_APPLICATION_DEBUG === "true",
  singpassLoginUrl: `${process.env.REACT_APP_API_DEV_BASE_URL}/oauth2/authorization/hdb-transfer-owner`,
  myHdbLoginURL: "https://services2.hdb.gov.sg/webapp/FI10PPORTAL/FI10PAtAGlance.jsp",
  singpassLogoutUrl: `${process.env.REACT_APP_API_DEV_BASE_URL}/user/logout`,
  devAndStgPaymentURL: "https://services2u.nicehomes.com.sg/webapp/AC28AWGatewayWeb/AC28QRProcessPayReq.jsp",
  prodPaymentURL: "https://services2.hdb.gov.sg/webapp/AC28AWGatewayWeb/AC28QRProcessPayReq.jsp",
  singpassRedirectUrl: `/dashboard`,
  corppassRedirectUrl: `/solicitor/dashboard`,
  showEstimateFees: process.env.REACT_APP_SHOW_ESTIMATED_FEES === "true",
  byPassBB13: process.env.REACT_APP_BYPASS_BB13 === "true",
  bypassEstateActionCode: process.env.REACT_APP_BYPASS_ESTATE_ACTION_CODE === "true",
  skipOutstandingFeesCheck: process.env.REACT_APP_SKIP_OUTSTANDING_FEES_CHECK === "true",
};

export default config;
